import dayjs from 'dayjs';

import { TONIGHT_TIME } from '../constants';

export default (timestamp, timezone) =>
  dayjs.unix(timestamp).tz(timezone).set(TONIGHT_TIME).unix();
